export const API_BASE = process.env.REACT_APP_API_BASE || (window.location.origin === 'http://localhost:3000' ? 'http://localhost:5000' : '');
